import { render, staticRenderFns } from "./Report.old.v1.vue?vue&type=template&id=ba224ed0&"
import script from "./Report.old.v1.vue?vue&type=script&lang=js&"
export * from "./Report.old.v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports